var USER = {
  doLogin: function () {
    FORMS.sendForm(
      event,
      '#form-login',
      'do_login.php',
      function (form_name) {
        return true;
      },
      function (response) {
        window.location = window.location.href.split('?')[0];
      },
      function (error) {
        if (error.data.active_account) {
          APP.closePopup('#modal-login');
          APP.openPopup('#modal-code');
          $('#form-code #email-code').val($('#form-login #email-login').val());
          $('#form-code #email-confirm').html($('#form-login #email-login').val());
          $('#form-code #pass-code').val($('#form-login #password-login').val());
        }
      },
      false
    );
  },
  doSendCode: function () {
    FORMS.sendForm(
      event,
      '#form-code',
      'do_send_code.php',
      function (form_name) {
        if (
          $('#form-code #code1').val() == '' ||
          $('#form-code #code2').val() == '' ||
          $('#form-code #code3').val() == '' ||
          $('#form-code #code4').val() == ''
        ) {
          FORMS.showUserMessage(
            TOKEN.CODE_EMPTY,
            FORMS.MESSAGE_ERROR,
            '#form-code .form-message',
            false
          );
          return false;
        }
        return true;
      },
      function (response) {
        window.location = window.location.href.split('?')[0];
      },
      function (error) {

      },
      false
    )
  },
  doSignup: function () {
    FORMS.sendForm(
      event,
      '#form-register',
      'signup.php',
      function (form_name) {
        if (
          $('#form-register #password').val() !=
          $('#form-register #password_confirm').val()
        ) {
          FORMS.showUserMessage(
            TOKEN.PASSWORD_NO_MATCH,
            FORMS.MESSAGE_ERROR,
            '#form-register .form-message',
            false
          );
          return false;
        }

        if (
          $('#form-register #agree:checked').length == 0 ||
          $('#form-register #agree2:checked').length == 0
        ) {
          FORMS.showUserMessage(
            TOKEN.AGREE_SIGN_UP_ERROR,
            FORMS.MESSAGE_ERROR,
            '#form-register .form-message',
            false
          );
          return false;
        }
        return true;
      },
      function (response) {



        APP.closePopup('#modal-register');
        APP.openPopup('#modal-code');
        $('#form-code #email-code').val($('#form-register #email').val());
        $('#form-code #email-confirm').html($('#form-register #email').val());
        $('#form-code #pass-code').val($('#form-register #password').val());
      },
      function (error) {
        console.log('nok callback', error);
      },
      false
    );
  },
  requestRecoverPassword: function () {
    FORMS.sendForm(
      event,
      '#form-recover-password',
      'request_recover_password.php',
      function (form_name) {
        return true;
      },
      function (response) {
        console.log(response);
        $('.button-request-recovery-password').addClass('is-hidden');
      },
      function (error) {
        console.log('nok callback', error);
      },
      false
    );
  },
  recoverPasswordUpdate: function () {
    FORMS.sendForm(
      event,
      '#form-set-password',
      'update_password.php',
      function (form_name) {
        if (
          $('#form-set-password-password-confirm').val() ==
          $('#form-set-password-password').val()
        )
          return true;
        else {
          FORMS.showUserMessage(
            TOKEN.PASSWORD_NO_MATCH,
            FORMS.MESSAGE_ERROR,
            '#form-set-password .form-message',
            false
          );
          return false;
        }
      },
      function (response) {
        console.log(response);
        $('#form-set-password-button').addClass('is-hidden');
      },
      function (error) {
        console.log('nok callback', error);
      },
      false
    );
  },
  logout: function () {
    axios
      .post('/requests/logout.php')
      .then(response => (window.location.href = '/'))
      .catch(console.error);
  },
  copyPersonalToInvoice: function () {
    $("input[name='invoice_name']").val(
      $("input[name='first_name']").val() +
      ' ' +
      $("input[name='last_name']").val()
    );

    $("input[name='invoice_city']").val($("input[name='city']").val());
    $("select[name='invoice_country']").val(
      $("select[name='country']  option:selected").val()
    );
  }
};
